import React from 'react';

export default function EmptyState({ message = 'Nenhum dado disponível' }) {
  return <div className="admin-empty">{message}</div>;
}
